import React from "react";

export default function AlertBullet({ error }) {
  return (
    <div style={{ minHeight: 32, minWidth: 40 }}>
      {error ? (
        <svg
          width="40"
          height="32"
          viewBox="0 0 40 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24 32C32.8366 32 40 24.8366 40 16C40 7.16344 32.8366 0 24 0C15.1634 0 0 0 0 0V32C0 32 15.1634 32 24 32Z"
            fill="#C5131C"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17 12.8L21.8 8H28.2L33 12.8V19.2L28.2 24H21.8L17 19.2V12.8ZM25.0064 19.2819C24.7675 19.2819 24.5627 19.1966 24.392 19.0259C24.2213 18.8553 24.136 18.6505 24.136 18.4115C24.136 18.1726 24.2213 17.9678 24.392 17.7971C24.5627 17.6265 24.7675 17.5411 25.0064 17.5411C25.2453 17.5411 25.4501 17.6265 25.6208 17.7971C25.7915 17.9678 25.8768 18.1726 25.8768 18.4115C25.8768 18.6505 25.7915 18.8553 25.6208 19.0259C25.4501 19.1966 25.2453 19.2819 25.0064 19.2819ZM24.232 13.6969L24.68 16.64H25.32L25.768 13.6969V12.16H24.232V13.6969Z"
            fill="white"
          />
        </svg>
      ) : (
        <svg
          width="40"
          height="32"
          viewBox="0 0 40 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24 32C32.8366 32 40 24.8366 40 16C40 7.16344 32.8366 0 24 0C15.1634 0 0 0 0 0V32C0 32 15.1634 32 24 32Z"
            fill="#4572C0"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17 12.8L21.8 8H28.2L33 12.8V19.2L28.2 24H21.8L17 19.2V12.8ZM25.0064 19.2819C24.7675 19.2819 24.5627 19.1966 24.392 19.0259C24.2213 18.8553 24.136 18.6505 24.136 18.4115C24.136 18.1726 24.2213 17.9678 24.392 17.7971C24.5627 17.6265 24.7675 17.5411 25.0064 17.5411C25.2453 17.5411 25.4501 17.6265 25.6208 17.7971C25.7915 17.9678 25.8768 18.1726 25.8768 18.4115C25.8768 18.6505 25.7915 18.8553 25.6208 19.0259C25.4501 19.1966 25.2453 19.2819 25.0064 19.2819ZM24.232 13.6969L24.68 16.64H25.32L25.768 13.6969V12.16H24.232V13.6969Z"
            fill="white"
          />
        </svg>
      )}
    </div>
  );
}
